import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, setSession, clearToken, getToken, getRefresh } from "@/lib/api";

const AuthContext = createContext({});
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const bootstrap = useCallback(async () => {
    setLoading(true);
    const token = getToken();
    if (token) {
      try {
        const me = await api.get("/auth/me");
        setUser(me);
      } catch {
        clearToken();
        setUser(null);
      }
    }
    setLoading(false);
  }, []);

  useEffect(() => {
    bootstrap();
  }, [bootstrap]);

  const login = useCallback(
    (email, password) => api.post("/auth/login", { email, password }, false),
    []
  );

  const verifyMfa = useCallback(async (challenge_id, code) => {
    const res = await api.post("/auth/mfa/verify", { challenge_id, code }, false);
    setSession(res.access_token, res.refresh_token);
    setUser(res.user);
    return res.user;
  }, []);

  const resetPassword = useCallback(
    (reset_token, new_password) =>
      api.post("/auth/password/reset", { reset_token, new_password }, false),
    []
  );

  const logout = useCallback(async () => {
    const refresh_token = getRefresh() || "";
    try {
      await api.post("/auth/logout", { refresh_token });
    } catch {}
    clearToken();
    setUser(null);
  }, []);

  return (
    <AuthContext.Provider
      value={{ user, loading, login, verifyMfa, resetPassword, logout, refresh: bootstrap, setUser }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export function roleHome(role) {
  if (role === "client") return "/client";
  if (role === "caregiver") return "/caregiver";
  if (role === "agency") return "/agency";
  return "/office";
}
